<template>
  <div class="row">
    <div class="col-md-12">
      <h5>{{ data.noteType }} Note: {{ data.department.name }}</h5>
        <div style="overflow:auto; max-height: 400px;">
          <ckeditor :editor="editor" v-model="data.note" :config="ckEditorConfig"></ckeditor>
        </div>
      <button type="button" @click="saveNote" class="btn btn-fill btn-info pull-right">
        Save Note
      </button>
    </div>
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import ckEditorConfig from 'src/utilities/ckeditor'

export default {
  props: ['data'],
  components: {
    ckeditor: CKEditor.component
  },
  data () {
    return {
      editor: ClassicEditor,
      ckEditorConfig
    }
  },
  methods: {
    saveNote() {
      this.$store.set('companies/companyNote', {
        noteType: this.data.noteType.toLowerCase(),
        departmentId: this.data.department.id,
        note: this.data.note
      })
      this.$eventHub.$emit('companyNoteSaved')
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
